import styled, { theme, mediaQuery, css, useMediaQuery, getSectionBackgroundStyle } from 'academy-common-lib/utils/Styling';
import { H2, H3 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AboutAcademySection = styled.section.withConfig({
  displayName: "PublicPageAboutAcademySection__AboutAcademySection",
  componentId: "sc-1ehhjkc-0"
})(["padding:24px 0 12px;", " ", ""], getSectionBackgroundStyle(theme.colors.GYPSUM), mediaQuery('tablet', css(["text-align:center;"])));
const AboutGrid = styled.div.withConfig({
  displayName: "PublicPageAboutAcademySection__AboutGrid",
  componentId: "sc-1ehhjkc-1"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));grid-gap:24px;padding-bottom:36px;"]);
const AboutGridItem = ({
  illustration,
  title,
  description
}) => {
  const {
    isTablet
  } = useMediaQuery();
  const illustrationSize = isTablet ? 80 : 128;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      className: "m-bottom-6",
      height: illustrationSize,
      loading: "lazy",
      name: illustration,
      width: illustrationSize
    }), /*#__PURE__*/_jsx(H3, {
      children: title
    }), description]
  });
};
const PublicPageAboutAcademySection = () => {
  return /*#__PURE__*/_jsxs(AboutAcademySection, {
    children: [/*#__PURE__*/_jsx(H2, {
      className: "m-bottom-10",
      style: {
        textAlign: 'center'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.whyLearnWithAcademy.title"
      })
    }), /*#__PURE__*/_jsxs(AboutGrid, {
      children: [/*#__PURE__*/_jsx(AboutGridItem, {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnWithAcademy.free.description"
        }),
        illustration: 'unlock',
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnWithAcademy.free.title"
        })
      }), /*#__PURE__*/_jsx(AboutGridItem, {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnWithAcademy.personalised.description"
        }),
        illustration: 'dedicated-ip-board',
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnWithAcademy.personalised.title"
        })
      }), /*#__PURE__*/_jsx(AboutGridItem, {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnWithAcademy.global.description"
        }),
        illustration: 'additional-hubspot-account-globe',
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.whyLearnWithAcademy.global.title"
        })
      })]
    })]
  });
};
export default PublicPageAboutAcademySection;